/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	export enum TerrainType {
		Photo = 'Texture',
		SurfaceElevation = 'Elevation',
		SurfaceGradient = 'Gradient',
		Surface = 'Surface',
		WireFrame = 'Wireframe',
		None = 'Naked',

		//PointCloud = 'Dots',
		//Plain = 'plain',
		//Info = 'info',
	}
}
